
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) 브라우저 메뉴 열기`,
's182ab2d6c997515f': `더 많은 기능과 쉬운 접근을 위해 홈 화면에 추가해주세요.`,
's1b9047d53d9f9d22': `2) 내비게이션 바에서 공유 버튼 누르기`,
's2d90afa5dcca2c0e': `3) "홈 화면에 추가"로 스크롤하기`,
's37a9e8aec5713460': `더보기`,
's4593f304dac8848c': `2) "홈 화면에 추가" 탭하기`,
's54cfbb14f46396d4': `1) 주 브라우저에서 열기`,
's6196153c4b0c1ea0': `설치`,
's922329d6f6213590': `Dock에 추가`,
'sa5ef80b4bb9b39f8': `닫기`,
'sa7551383d1897fcc': `2) Dock에 추가 버튼 누르기`,
'sba52286c21552a4e': `더 많은 기능과 쉬운 접근을 위해 기기에 설치해주세요.`,
'sc79fd7641eb9a975': `안내 숨기기`,
'scdaf4bbff76674c8': `홈 화면에 추가`,
'se740f75b95a51807': `더 많은 기능과 쉬운 접근을 위해 Dock에 추가해주세요.`,
'sfea652f6580ff086': `이 사이트는 앱 기능을 가지고 있습니다.`,
    };
  